var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurTeamRightStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 811.79 512.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "552.88 54.21 555.85 63.34 565.45 63.34 557.68 68.98 560.65 78.11 552.88 72.47 545.11 78.11 548.08 68.98 540.31 63.34 549.91 63.34 552.88 54.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "765.27 154 766.61 158.11 770.92 158.11 767.43 160.65 768.76 164.75 765.27 162.21 761.78 164.75 763.11 160.65 759.62 158.11 763.94 158.11 765.27 154"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "285.3 11.14 286.64 15.25 290.96 15.25 287.46 17.79 288.8 21.89 285.3 19.36 281.81 21.89 283.15 17.79 279.65 15.25 283.97 15.25 285.3 11.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.65 5.77 6.99 9.87 11.31 9.87 7.81 12.41 9.15 16.52 5.65 13.98 2.16 16.52 3.49 12.41 0 9.87 4.32 9.87 5.65 5.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "416.61 34.39 417.94 38.5 422.26 38.5 418.77 41.03 420.1 45.14 416.61 42.6 413.11 45.14 414.45 41.03 410.96 38.5 415.27 38.5 416.61 34.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "480.15 122.54 481.48 126.65 485.8 126.65 482.3 129.19 483.64 133.29 480.15 130.75 476.65 133.29 477.99 129.19 474.49 126.65 478.81 126.65 480.15 122.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "637.54 34.39 638.88 38.5 643.2 38.5 639.7 41.03 641.04 45.14 637.54 42.6 634.05 45.14 635.38 41.03 631.89 38.5 636.21 38.5 637.54 34.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "612.88 0 614.21 4.11 618.53 4.11 615.04 6.65 616.37 10.75 612.88 8.21 609.39 10.75 610.72 6.65 607.23 4.11 611.55 4.11 612.88 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "607.23 159.38 608.56 163.48 612.88 163.48 609.39 166.02 610.72 170.13 607.23 167.59 603.73 170.13 605.07 166.02 601.57 163.48 605.89 163.48 607.23 159.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "744.87 45.46 746.21 49.57 750.53 49.57 747.03 52.11 748.37 56.22 744.87 53.68 741.38 56.22 742.71 52.11 739.22 49.57 743.54 49.57 744.87 45.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "697.3 127.92 698.64 132.02 702.96 132.02 699.46 134.56 700.8 138.67 697.3 136.13 693.81 138.67 695.15 134.56 691.65 132.02 695.97 132.02 697.3 127.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "790.81 406.27 792.14 410.38 796.46 410.38 792.97 412.91 794.3 417.02 790.81 414.48 787.32 417.02 788.65 412.91 785.16 410.38 789.48 410.38 790.81 406.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "726.65 297.93 727.99 302.04 732.3 302.04 728.81 304.57 730.14 308.68 726.65 306.14 723.16 308.68 724.49 304.57 721 302.04 725.32 302.04 726.65 297.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "806.14 303.31 807.47 307.41 811.79 307.41 808.3 309.95 809.63 314.06 806.14 311.52 802.65 314.06 803.98 309.95 800.49 307.41 804.81 307.41 806.14 303.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "744.87 235.6 747.84 244.74 757.44 244.74 749.67 250.38 752.64 259.51 744.87 253.87 737.1 259.51 740.07 250.38 732.3 244.74 741.91 244.74 744.87 235.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "770.92 488.61 773.89 497.74 783.49 497.74 775.72 503.38 778.69 512.51 770.92 506.87 763.16 512.51 766.12 503.38 758.36 497.74 767.96 497.74 770.92 488.61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurTeamRightStars);
export default __webpack_public_path__ + "static/media/our_team_right_stars.7f89d307dcaa6df141eac9d42f3f11ae.svg";
export { ForwardRef as ReactComponent };